(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["magnets-final-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var el = document.querySelector('[data-mg-sticky]');
    if (!el) return;
    var trigger = window.innerHeight * 0.6;
    function onScroll() {
      if (window.scrollY > trigger) el.classList.add('is-on');
      else el.classList.remove('is-on');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnets-product-grid-marche"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mg-grid').forEach(function (grid) {
      var filtersWrap = grid.querySelector('[data-mg-filters]');
      var list = grid.querySelector('[data-mg-list]');
      if (!filtersWrap || !list) return;
      var chips = filtersWrap.querySelectorAll('.mg-grid__chip');
      var cards = list.querySelectorAll('.mg-card');

      function apply(filterId) {
        chips.forEach(function (c) {
          c.classList.toggle('is-on', c.dataset.mgFilter === filterId);
        });
        cards.forEach(function (card) {
          if (filterId === 'all') {
            card.style.display = '';
            return;
          }
          var ids = (card.getAttribute('data-mg-filters') || '').split(/\s+/);
          card.style.display = ids.indexOf(filterId) !== -1 ? '' : 'none';
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          apply(chip.dataset.mgFilter);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnets-product-grid"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.mg-grid').forEach(function (grid) {
      var filtersWrap = grid.querySelector('[data-mg-filters]');
      var list = grid.querySelector('[data-mg-list]');
      if (!filtersWrap || !list) return;
      var chips = filtersWrap.querySelectorAll('.mg-grid__chip');
      var cards = list.querySelectorAll('.mg-card');

      function apply(filterId) {
        chips.forEach(function (c) {
          c.classList.toggle('is-on', c.dataset.mgFilter === filterId);
        });
        cards.forEach(function (card) {
          if (filterId === 'all') {
            card.style.display = '';
            return;
          }
          var ids = (card.getAttribute('data-mg-filters') || '').split(/\s+/);
          card.style.display = ids.indexOf(filterId) !== -1 ? '' : 'none';
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function (e) {
          e.preventDefault();
          apply(chip.dataset.mgFilter);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["magnets-product-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.currentScript ? document.currentScript.closest('.mp') : document.querySelector('.mp');
    if (!root) return;
    var json = root.querySelector('[data-product-json]');
    if (!json) return;
    var product;
    try { product = JSON.parse(json.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-form]');
    if (!form) return;
    var variantInput = form.querySelector('input[name="id"]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var badgeSale = root.querySelector('[data-badge-sale]');
    var addBtn = form.querySelector('[data-add]');
    var addText = form.querySelector('[data-add-text]');
    var addPrice = form.querySelector('[data-add-price]');
    var stickyPrice = root.querySelector('[data-sticky-price]');
    var sticky = root.querySelector('[data-sticky]');
    var currencySymbol = '€';
    function money(cents) {
      if (cents == null) return '';
      var v = (cents / 100).toFixed(2).replace('.', ',');
      return v + ' ' + currencySymbol;
    }
    function getSelected() {
      if (!product.options) return null;
      var values = [];
      for (var i = 0; i < product.options.length; i++) {
        var name = product.options[i];
        var sel = form.querySelector('input[name="options[' + name + ']"]:checked');
        if (!sel) return null;
        values.push(sel.value);
      }
      return values;
    }
    function findVariant(values) {
      if (!values) return null;
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === values[i]; });
      });
    }
    function updateOptionLabels() {
      var legends = root.querySelectorAll('[data-option-current]');
      legends.forEach(function (el) {
        var idx = parseInt(el.dataset.optionCurrent, 10);
        var name = product.options[idx];
        var sel = form.querySelector('input[name="options[' + name + ']"]:checked');
        if (sel) el.textContent = sel.value;
      });
    }
    function updateUI() {
      updateOptionLabels();
      var values = getSelected();
      var variant = findVariant(values);
      if (!variant) {
        if (addBtn) { addBtn.disabled = true; addText.textContent = 'Indisponible'; }
        return;
      }
      if (variantInput) variantInput.value = variant.id;
      if (priceEl) priceEl.textContent = money(variant.price);
      if (addPrice) addPrice.textContent = '· ' + money(variant.price);
      if (stickyPrice) stickyPrice.textContent = money(variant.price);
      var onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (compareEl) {
        if (onSale) { compareEl.textContent = money(variant.compare_at_price); compareEl.hidden = false; }
        else { compareEl.hidden = true; }
      }
      if (badgeSale) {
        if (onSale) {
          var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
          badgeSale.textContent = '-' + pct + '%'; badgeSale.hidden = false;
        } else { badgeSale.hidden = true; }
      }
      if (addBtn) {
        addBtn.disabled = !variant.available;
        addText.textContent = variant.available ? (root.dataset.addLabel || 'Ajouter au panier') : 'Épuisé';
      }
      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      } catch (e) {}
    }
    var radios = form.querySelectorAll('[data-option-input]');
    radios.forEach(function (r) { r.addEventListener('change', updateUI); });
    var qty = form.querySelector('[data-qty]');
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    if (qty && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () { var v = Math.max(1, (parseInt(qty.value, 10) || 1) - 1); qty.value = v; });
      qtyPlus.addEventListener('click', function () { var v = (parseInt(qty.value, 10) || 1) + 1; qty.value = v; });
    }
    var upInput = root.querySelector('[data-upload-input]');
    var upPh = root.querySelector('[data-upload-ph]');
    var upPreview = root.querySelector('[data-upload-preview]');
    var upImg = root.querySelector('[data-upload-img]');
    var upName = root.querySelector('[data-upload-name]');
    var upChange = root.querySelector('[data-upload-change]');
    var upError = root.querySelector('[data-upload-error]');
    var maxBytes = 20 * 1024 * 1024;
    if (upInput) {
      upInput.addEventListener('change', function (e) {
        var file = e.target.files && e.target.files[0];
        if (upError) { upError.hidden = true; upError.textContent = ''; }
        if (!file) return;
        if (file.size > maxBytes) {
          upInput.value = '';
          if (upError) { upError.textContent = 'Image trop volumineuse (max 20 Mo).'; upError.hidden = false; }
          return;
        }
        var reader = new FileReader();
        reader.onload = function () {
          if (upImg) upImg.src = reader.result;
          if (upName) upName.textContent = file.name;
          if (upPh) upPh.hidden = true;
          if (upPreview) upPreview.hidden = false;
        };
        reader.readAsDataURL(file);
      });
    }
    if (upChange && upInput) {
      upChange.addEventListener('click', function (e) { e.preventDefault(); upInput.click(); });
    }
    if (upPh && upInput) { upPh.addEventListener('click', function () { upInput.click(); }); }
    if (sticky && addBtn) {
      var triggerEl = root.querySelector('[data-add]');
      var stickyCta = sticky.querySelector('[data-sticky-cta]');
      if (stickyCta) {
        stickyCta.addEventListener('click', function () {
          var rect = triggerEl.getBoundingClientRect();
          window.scrollTo({ top: window.scrollY + rect.top - 100, behavior: 'smooth' });
        });
      }
      var onScroll = function () {
        if (!triggerEl) return;
        var rect = triggerEl.getBoundingClientRect();
        var hidden = rect.top < window.innerHeight && rect.bottom > 0;
        sticky.hidden = hidden;
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
